<template>
  <MagentoPatchesTable :patches="patches" :service="service" :status="status" />
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import MagentoPatchesTable from "@/components/smart/tables/MagentoPatchesTable";
import store from "@/store";

export default {
  name: "SafeHarborMagentoPatchesPage",
  components: { MagentoPatchesTable },
  setup() {
    const patches = computed(() => store.getters["safeHarbor/getSitePatches"]);
    const service = computed(() => store.getters["plans/getItem"]);
    const status = computed(() => store.getters["safeHarbor/getSitePatchesStatus"]);

    onMounted(() => {
      store.dispatch("safeHarbor/getSitePatches", service.value.cloudAccount.id);
    });

    return {
      patches,
      service,
      status,
    };
  },
};
</script>
